<template>
  <div class="signup">
    <div>
      <el-form ref="form" :model="form" :rules="rules" label-width="160px" class="form">
      <h2 class="text-center form__title mb-3">
        <!-- {{ $t('singup.createNewTutor') }} -->
        Register as tutor
      </h2>
        <el-form-item label="First name" prop="firstName">
          <el-input v-model="form.firstName"></el-input>
        </el-form-item>
        <el-form-item label="Last name" prop="lastName">
          <el-input v-model="form.lastName"></el-input>
        </el-form-item>
        <el-form-item label="Email" prop="email">
          <el-input v-model="form.email"></el-input>
        </el-form-item>
        <el-form-item label="Zip code" prop="zipCode">
          <el-input v-model="form.zipCode" v-mask="'99999'"></el-input>
        </el-form-item>
        <el-form-item label="Phone number" prop="phoneNumber">
          <el-input v-model="form.phoneNumber" v-mask="'(999) 999 9999'"></el-input>
        </el-form-item>
        <el-form-item label="TPM License number" prop="licenseNumber">
          <el-input v-model="form.licenseNumber" v-mask="'TPM 999 999 999 999 999 999'"></el-input>
        </el-form-item>
        <el-form-item label="Box number" prop="boxNumber">
          <el-input v-model.number="form.boxNumber" v-mask="'9999999'"></el-input>
        </el-form-item>
        <el-form-item label="Username" prop="username">
          <el-input v-model="form.username"></el-input>
        </el-form-item>
        <el-form-item label="Password" prop="password">
          <el-input v-model="form.password" type="password" autocomplete="off" show-password></el-input>
        </el-form-item>
        <el-form-item label="Confirm" prop="checkPassword">
          <el-input v-model="form.checkPassword" type="password" autocomplete="off" show-password></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="submitForm('form')">Create</el-button>
          <el-button size="small" @click="resetForm('form')">Cancel</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Signup',
  data: function () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password'));
      } else {
        if (this.form.checkPassword !== '') {
          this.$refs.form.validateField('checkPassword');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password again'));
      } else if (value !== this.form.password) {
        callback(new Error("Two inputs don't match!"));
      } else {
        callback();
      }
    };
    var checkUsername = (rule, value, callback) => {
      if (value != '') {
        this.$httpMain
          .post(`find-username`, {
            username: this.form.username,
          })
          .then(res => {
            if (res.data === true) {
              callback(new Error('this username already exist'));
            } else {
              callback();
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    };
    return {
      form: {
        firstName: '',
        lastName: '',
        email: '',
        zipCode: null,
        phoneNumber: null,
        boxNumber: null,
        licenseNumber: null,
        username: '',
        password: '',
        checkPassword: '',
      },
      rules: {
        firstName: [
          { required: true, message: 'Please input first name', trigger: 'blur' },
          { min: 3, max: 20, message: 'Length should be 3 to 20', trigger: 'blur' },
        ],
        lastName: [
          { required: true, message: 'Please input last name', trigger: 'blur' },
          { min: 3, max: 20, message: 'Length should be 3 to 20', trigger: 'blur' },
        ],
        boxNumber: [
          {
            required: true,
            message: 'Please input box license number',
            trigger: 'blur',
          },
        ],
        licenseNumber: [
          {
            required: true,
            message: 'Please input box number',
            trigger: 'blur',
          },
          //{ type: 'number', message: 'The box number must be numbers' },
        ],
        email: [
          { required: true, message: 'Please input email address', trigger: 'blur' },
          {
            type: 'email',
            message: 'Please input correct email address',
            trigger: ['blur', 'change'],
          },
        ],
        zipCode: [
          { required: true, message: 'Please input zip code', trigger: 'blur' },
          {
            type: 'string',
            message: 'Please input correct zip code',
            trigger: ['blur', 'change'],
            len: 5,
          },
        ],
        phoneNumber: [
          { required: true, message: 'Please input phone number', trigger: 'blur' },
          {
            type: 'string',
            message: 'Please input correct phone number',
            trigger: ['blur', 'change'],
            len: 14,
          },
        ],
        username: [
          { validator: checkUsername, trigger: 'blur' },
          { required: true, message: 'Please input username', trigger: 'blur' },
          { min: 3, max: 25, message: 'Length should be 3 to 25', trigger: 'blur' },
        ],
        password: [
          { validator: validatePass, trigger: 'blur' },
          { required: true, message: 'Please input password', trigger: 'blur' },
          { min: 3, max: 25, message: 'Length should be 3 to 25', trigger: 'blur' },
        ],
        checkPassword: [{ validator: validatePass2, trigger: 'blur' }],
      },
    };
  },
  // computed: {
  //   ...mapGetters({
  //     authenticatedUser: 'auth/authenticatedUser',
  //   }),
  // },
  created() {
    // FIXME: se considera el id del usuario para identificar a Sr. Francisco o Sr. Hugo, implementar CASL
    // if (this.authenticatedUser.id === 3219 || this.authenticatedUser.id === 3517) {
    //   delete this.rules['boxNumber'];
    //   delete this.rules['licenseNumber'];
    // }
  },
  methods: {
    resetForm(formName) {
      this.$emit('cancel');
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let licenseNumber;
          try {
            licenseNumber = this.form.licenseNumber.replace(/\s/g, '');
          } catch (_) {
            licenseNumber = '';
          }
          this.$httpMain
            .post(`signup/tutor`, {
              firstname: this.form.firstName,
              lastname: this.form.lastName,
              email: this.form.email,
              zip_code: this.form.zipCode,
              phone_number: this.form.phoneNumber,
              box_number: Number.parseInt(this.form.boxNumber),
              license_number: licenseNumber.toLowerCase(),
              username: this.form.username,
              password: this.form.password,
              // tutor_id: this.authenticatedUser.id,
              rol_id: 2,
              language: 'en',
            })
            .then(() => {
              this.$notify({
                title: 'Success',
                message: 'Tutor successfully created',
                type: 'success',
                position: 'bottom-right',
              });
              this.$refs[formName].resetFields();
            })
            .catch(err => {
              this.$notify({
                title: 'Error',
                message: err.message,
                type: 'err',
                position: 'bottom-right',
              });
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.signup
  background-color: #fff
  border-radius: 10px
  padding: 2rem
  display: flex
  justify-content: center
  align-items: center
  // min-height: calc(100vh - 35px)
  +forDesktop
    // margin-top: 5em
    min-height: unset
.form
  background-color: #fff
  border-radius: 10px
  padding: 1.8rem 1.2rem
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.5)
  +forDesktop
    width: 600px
  +element('title')
    font-size: 26px
</style>
